module.exports = __webpack_public_path__ + "static/media/water1.81d208b0.svg";